import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

const faqData = [
  {
    heading: "What type of developers can I hire from Shine Infosoft?",
    text: "We offer experienced developers skilled in over 20+ technologies, including Python, Microsoft .NET Core, React.js, Node.js, Angular, Laravel, React Native, iOS, Android, and more - ready to work on your specific project needs.",
  },
  {
    heading: "How quickly can I hire a developer?",
    text: "You can hire a developer in as little as <strong>24–72 hours</strong> after sharing your requirements. We’ll provide you with pre-vetted, curated profiles for fast onboarding.",
  },
  {
    heading: "Can I interview and select the developer myself?",
    text: "<strong>Absolutely.</strong> You’ll receive shortlisted candidates, and you can interview, test, and choose the developer that best fits your team and goals.",
  },
  {
    heading: "What are your engagement models?",
    text: "We offer flexible hiring models — hourly, part-time, or full-time dedicated developers based on your project's scope and budget.",
  },
  {
    heading: "Will the developer work in my time zone?",
    text: "<strong>Yes.</strong> Our remote developers adjust to your preferred working hours and ensure availability during your core business time.",
  },
  {
    heading: "How do you ensure the quality of work?",
    text: "Our developers go through a strict technical screening and are monitored by senior project leads to ensure timely, high-quality delivery.",
  },
  {
    heading: "Is there a minimum hiring period?",
    text: "We’re flexible. You can hire for short-term needs (a few weeks) or long-term projects — with <strong>no lengthy contracts or commitments.</strong>",
  },
  {
    heading: "What if I'm not satisfied with the developer?",
    text: "If the developer isn’t the right fit, we’ll <strong>replace them immediately at no extra cost</strong>, ensuring your project stays on track.",
  },
  {
    heading: "Do you sign NDAs and ensure data security?",
    text: "<strong>Yes,</strong> we sign <strong>NDAs and follow strict security protocols</strong> to protect your code, data, and business confidentiality.",
  },
  {
    heading: "What’s the cost of hiring a developer?",
    text: 'Our pricing is competitive and based on the developer’s skill level and your project requirements. Contact us for a <a href="/ContactUs"><strong>custom quote</strong></a>.'
  },
];

const Faq = () => {
  return (
    <>
      <section className="hireFaqSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading" data-aos="slide-right">
                <h3>
                  Frequently Asked <span>Questions</span>
                </h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Accordion>
                {faqData.map((each, i) => (
                  <AccordionItem
                    className="ac-item"
                    key={i}
                    data-aos="slide-up"
                  >
                    <AccordionItemHeading>
                      <AccordionItemButton className="ac-heading">
                        {each.heading}
                      </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel className="ac-panel">
                      <p dangerouslySetInnerHTML={{ __html: each.text }} />
                    </AccordionItemPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
